// frontend/OtoScopDataUi.jsx
import React, { useEffect, useMemo } from "react";
import {
  Box,
  Typography,
  CardMedia,
  Grid,
  Button,
  Autocomplete,
  RadioGroup,
  FormControlLabel,
  Radio,
  Divider,
  Paper,
} from "@mui/material";
import QRCode from "react-qr-code";
import rightear from "../../../assets/images/left-ear.png";
import leftear from "../../../assets/images/right-ear.png";
import CustomInput from "../../../components/inputs/CustomInput";
import { DRUM, WAX } from "../../../utils/constants";
import { findObjectKeyByValue, titleCase } from "../../../utils/helper";

const OtoScopDataUi = ({
  fields,
  setFields,
  fetchFunction,
  isView,
  errors,
}) => {
  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        overflow: "auto",
        scrollbarWidth: "none",
      }}
    >
      <Grid md={12} container>
        {!isView && (
          <Grid
            md={3}
            sm={3}
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-around",
              alignItems: "flex-start",
              padding: 2,
              borderRight: " 2px solid #EBEBEB",
            }}
          >
            <Box
              gap={4}
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                alignItems: "flex-start",
              }}
            >
              <Box
                gap={4}
                sx={{
                  display: "flex",
                  alignItems: "flex-end",
                  justifyContent: "space-between",
                }}
              >
                <Typography
                  variant="h5"
                  sx={{
                    color: "#2D3B67",
                    fontFamily: "League Spartan",
                    fontWeight: 700,
                  }}
                >
                  Follow the instructions provided:
                </Typography>
              </Box>
            </Box>
            <Box
              width={"100%"}
              sx={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                gap: 2,
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  color: "#2D3B67",
                  fontFamily: "League Spartan",
                  textAlign: "left",
                }}
              >
                1.
              </Typography>
              <Typography
                variant="h6"
                sx={{
                  color: "#2D3B67",
                  fontFamily: "League Spartan",
                  textAlign: "left",
                }}
              >
                Download & Open the NUScope App.
              </Typography>
            </Box>

            {!isView && (
              <>
                {/* <Box
                  sx={{
                    height: 200,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100%",
                  }}
                > */}
                <Box display={"flex"} alignItems={"center"} gap={2}>
                  <Typography
                    variant="h6"
                    sx={{
                      color: "#2D3B67",
                      fontFamily: "League Spartan",
                      textAlign: "left",
                    }}
                  >
                    2.
                  </Typography>
                  <Typography
                    variant="h6"
                    sx={{
                      color: "#2D3B67",
                      fontFamily: "League Spartan",
                      textAlign: "left",
                    }}
                  >
                    Scan the Patient QR Code.
                  </Typography>
                </Box>
                <Box
                  sx={{
                    // height: 200,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    // justifyContent: "center",
                    width: "100%",
                  }}
                >
                  <Paper
                    elevation={3}
                    sx={{
                      padding: 4,
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <QRCode
                      size={150}
                      // style={{ height: "auto", maxWidth: "100%" }}
                      value={fields?._id || "No Patient ID"}
                    />
                  </Paper>
                </Box>
              </>
            )}
            <Box />
            <Box
              width={"100%"}
              sx={{
                display: "flex",
                justifyContent: "flex-start",
                gap: 2,
                alignItems: "center",
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  color: "#2D3B67",
                  fontFamily: "League Spartan",
                  textAlign: "left",
                }}
              >
                3.
              </Typography>
              <Typography
                variant="h6"
                sx={{
                  color: "#2D3B67",
                  fontFamily: "League Spartan",
                  textAlign: "left",
                }}
              >
                Capture Ear Images Using Otoscope.
              </Typography>
            </Box>
            <Box
              width={"100%"}
              sx={{
                display: "flex",
                justifyContent: "flex-start",
                gap: 2,
                alignItems: "flex-start",
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  color: "#2D3B67",
                  fontFamily: "League Spartan",
                  textAlign: "left",
                }}
              >
                4.
              </Typography>
              <Typography
                variant="h6"
                sx={{
                  color: "#2D3B67",
                  fontFamily: "League Spartan",
                  textAlign: "left",
                }}
              >
                Upload ear photos via the app and
                <br /> load them here to continue the
                <br /> process.
              </Typography>
            </Box>
            <Box
              width={"100%"}
              sx={{ display: "flex", justifyContent: "center" }}
            >
              <Button
                variant="outlined"
                size="large"
                onClick={() => {
                  fetchFunction(fields?.patient_uid);
                }}
                sx={{ mt: 2, width: "15vw" }}
              >
                <Typography variant="h5">Load Images</Typography>
              </Button>
            </Box>
          </Grid>
        )}

        <Grid
          item
          md={4.5}
          sm={4.5}
          sx={{
            padding: 4,
            backgroundColor: "#FCF7F7",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-around",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-around",
              alignItems: "center",
              gap: 4,
            }}
          >
            <Box
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                mt: 2,
              }}
            >
              <Typography variant="h2" sx={{ color: "rgba(194, 71, 71, 1)" }}>
                Right Ear
              </Typography>
            </Box>
            <Box
              sx={{
                // p: 2,
                border: "20px solid #EED2D2",

                borderRadius: "50%",
                maxHeight: "35vh",
                maxWidth: "35vh",
                overflow: "hidden",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {fields?.right_ear ? (
                <CardMedia
                  component="img"
                  image={fields.right_ear}
                  alt="Right Ear"
                />
              ) : (
                <CardMedia component="img" image={rightear} alt="Right Ear" />
              )}
            </Box>
          </Box>

          <Box mb={2} sx={{ width: "25vw", height: "30vh" }}>
            <Autocomplete
              disableClearable
              disabled={isView}
              value={
                fields?.right_ear_wax
                  ? findObjectKeyByValue(fields?.right_ear_wax, WAX)
                  : null
              }
              onChange={(e, newVal) => {
                setFields({
                  ...fields,
                  right_ear_wax: newVal ? newVal._id : null,
                  other_right_wax: "",
                });
              }}
              options={[
                ...Object.keys(WAX).map((key) => ({
                  label: titleCase(key),
                  _id: WAX[key],
                })),
              ]}
              sx={{
                width: "100%",
                display: "flex",
                "*": { display: "flex", justifyContent: "center" },
              }}
              renderInput={(fields) => (
                <CustomInput
                  placeholder="Select Right Wax"
                  {...fields}
                  label="Select Right Wax"
                />
              )}
            />
            {errors?.otherRightWax && (
              <Typography color="error" mt={0.5} variant="body2">
                Other Right Ear Wax is Required *
              </Typography>
            )}
            {fields.right_ear_wax == WAX.OTHER && (
              <CustomInput
                value={fields.other_right_wax}
                onChange={(e) =>
                  setFields({
                    ...fields,
                    err: "",
                    other_right_wax: e.target.value,
                  })
                }
                type="text"
                label={"Other Right Ear Wax"}
              />
            )}
            <Autocomplete
              disableClearable
              disabled={isView}
              value={
                fields?.right_eardrum
                  ? findObjectKeyByValue(fields?.right_eardrum, DRUM)
                  : null
              }
              onChange={(e, newVal) => {
                const newEardrum = newVal ? newVal._id : null;
                setFields({
                  ...fields,
                  right_eardrum: newEardrum,
                  is_discharge_right:
                    newEardrum === DRUM.PERFORATED ? true : null,
                  other_right_drum: "",
                });
                // setFields({ ...fields, right_eardrum: newVal ? newVal._id : null ,is_discharge_right: fields.right_eardrum === DRUM.PERFORATED ? fields.is_discharge_right : null})
              }}
              options={[
                ...Object.keys(DRUM).map((key) => ({
                  label: titleCase(key),
                  _id: DRUM[key],
                })),
              ]}
              sx={{
                width: "100%",
                display: "flex",
                "*": { display: "flex", justifyContent: "center" },
              }}
              renderInput={(fields) => (
                <CustomInput
                  placeholder="Select Right Drum"
                  {...fields}
                  label="Select Right Drum"
                />
              )}
            />
            {fields?.right_eardrum == DRUM.PERFORATED && (
              <Box sx={{ marginLeft: "10px" }}>
                <RadioGroup
                  sx={{
                    top: "-6px",
                    left: "90px",
                  }}
                  row
                  disabled={isView}
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                >
                  <Box sx={{ display: "flex" }}>
                    <FormControlLabel
                      // disabled={loading}
                      disabled={isView}
                      checked={fields?.is_discharge_right == true}
                      onChange={(e) => {
                        setFields({ ...fields, is_discharge_right: true });
                      }}
                      value={true}
                      control={<Radio />}
                      label={
                        <Typography variant="h6">Discharge Active</Typography>
                      }
                    />
                    <FormControlLabel
                      disabled={isView}
                      checked={fields?.is_discharge_right == false}
                      onChange={(e) => {
                        setFields({ ...fields, is_discharge_right: false });
                      }}
                      // disabled={loading}
                      value={false}
                      control={<Radio />}
                      label={
                        <Typography variant="h6">Discharge Inactive</Typography>
                      }
                    />
                  </Box>
                </RadioGroup>
              </Box>
            )}
            {errors?.otherRightDrum && (
              <Typography color="error" mt={0.5} variant="body2">
                Other Right Ear Drum is Required *
              </Typography>
            )}
            {fields.right_eardrum == DRUM.OTHER && (
              <CustomInput
                value={fields.other_right_drum}
                onChange={(e) =>
                  setFields({
                    ...fields,
                    err: "",
                    other_right_drum: e.target.value,
                  })
                }
                type="text"
                label={"Other Right Ear Drum"}
              />
            )}
          </Box>
        </Grid>

        <Grid
          item
          md={4.5}
          sm={4.5}
          sx={{
            padding: 4,
            backgroundColor: "#F6FBFE",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-around",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-around",
              alignItems: "center",
              gap: 4,
            }}
          >
            <Box
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                mt: 2,
              }}
            >
              <Typography variant="h2" sx={{ color: "rgba(18, 101, 161, 1)" }}>
                Left Ear
              </Typography>
            </Box>

            <Box
              sx={{
                // p: 2,
                border: "20px solid #C8E7F9",
                borderRadius: "50%",
                maxHeight: "35vh",
                maxWidth: "35vh",
                overflow: "hidden",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {fields?.left_ear ? (
                <CardMedia
                  component="img"
                  image={fields.left_ear}
                  alt="Left Ear"
                />
              ) : (
                <CardMedia
                  component="img"
                  // height="350"
                  image={leftear}
                  alt="Left Ear"
                />
              )}
            </Box>
          </Box>

          <Box mb={2} sx={{ width: "25vw", height: "30vh" }}>
            <Autocomplete
              disableClearable
              disabled={isView}
              value={
                fields?.left_ear_wax
                  ? findObjectKeyByValue(fields?.left_ear_wax, WAX)
                  : null
              }
              onChange={(e, newVal) => {
                setFields({
                  ...fields,
                  left_ear_wax: newVal ? newVal._id : null,
                  other_left_wax: "",
                });
              }}
              options={[
                ...Object.keys(WAX).map((key) => ({
                  label: titleCase(key),
                  _id: WAX[key],
                })),
              ]}
              sx={{
                width: "100%",
                display: "flex",
                "*": { display: "flex", justifyContent: "center" },
              }}
              renderInput={(fields) => (
                <CustomInput
                  placeholder="Select Left Wax"
                  {...fields}
                  label="Select Left Wax"
                />
              )}
            />
            {errors?.otherLeftWax && (
              <Typography color="error" mt={0.5} variant="body2">
                Other Left Ear Wax is Required *
              </Typography>
            )}
            {fields.left_ear_wax == WAX.OTHER && (
              <CustomInput
                value={fields.other_left_wax}
                onChange={(e) =>
                  setFields({
                    ...fields,
                    err: "",
                    other_left_wax: e.target.value,
                  })
                }
                type="text"
                label={"Other Left Ear Wax"}
              />
            )}
            <Autocomplete
              disableClearable
              disabled={isView}
              value={
                fields?.left_eardrum
                  ? findObjectKeyByValue(fields?.left_eardrum, DRUM)
                  : null
              }
              onChange={(e, newVal) => {
                const newEardrum = newVal ? newVal._id : null;
                setFields({
                  ...fields,
                  left_eardrum: newEardrum,
                  is_discharge_left:
                    newEardrum === DRUM.PERFORATED ? true : null,
                  other_left_drum: "",
                });
                // setFields({ ...fields, left_eardrum: newVal ? newVal._id : null,is_discharge_left: fields.left_eardrum === DRUM.PERFORATED ? fields.is_discharge_left : null })
              }}
              options={[
                ...Object.keys(DRUM).map((key) => ({
                  label: titleCase(key),
                  _id: DRUM[key],
                })),
              ]}
              sx={{
                width: "100%",
                display: "flex",
                "*": { display: "flex", justifyContent: "center" },
              }}
              renderInput={(fields) => (
                <CustomInput
                  placeholder="Select Left Drum"
                  {...fields}
                  label="Select Left Drum"
                />
              )}
            />
            {errors?.otherLeftDrum && (
              <Typography color="error" mt={0.5} variant="body2">
                Other Left Ear Drum is Required *
              </Typography>
            )}
            {fields?.left_eardrum == DRUM.PERFORATED && (
              <Box sx={{ marginLeft: "10px" }}>
                <RadioGroup
                  sx={{
                    top: "-6px",
                    left: "90px",
                  }}
                  // disabled={isView}
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                >
                  <Box sx={{ display: "flex" }}>
                    <FormControlLabel
                      // disabled={loading}
                      disabled={isView}
                      checked={fields?.is_discharge_left === true}
                      onChange={(e) => {
                        setFields({ ...fields, is_discharge_left: true });
                      }}
                      value={true}
                      control={<Radio />}
                      label={
                        <Typography variant="h6">Discharge Active</Typography>
                      }
                    />
                    <FormControlLabel
                      disabled={isView}
                      checked={fields?.is_discharge_left === false}
                      onChange={(e) => {
                        setFields({ ...fields, is_discharge_left: false });
                      }}
                      // disabled={loading}
                      value={false}
                      control={<Radio />}
                      label={
                        <Typography variant="h6">Discharge Inactive</Typography>
                      }
                    />
                  </Box>
                </RadioGroup>
              </Box>
            )}
            {fields.left_eardrum == DRUM.OTHER && (
              <CustomInput
                value={fields.other_left_drum}
                onChange={(e) =>
                  setFields({
                    ...fields,
                    err: "",
                    other_left_drum: e.target.value,
                  })
                }
                type="text"
                label={"Other Left Ear Drum"}
              />
            )}
          </Box>
        </Grid>

        {/* <Box sx={{ marginTop: "-100px", width: "10px", height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}> <Box sx={{ backgroundColor: "rgba(194, 71, 71, 1)", width: "10px", height: "60%", borderTopLeftRadius: "10px", borderBottomLeftRadius: "10px" }}></Box></Box> */}
      </Grid>
    </Box>
  );
};

export default OtoScopDataUi;
